import { useState } from 'react';
import { Common } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import { streamTypes, STREAM_STATE } from '../constants';
import { getActiveCategory } from '../utils';
import NavigationDropdown from './NavigationDropdown';
import { DropdownOption, DropdownWrapper } from './styled';

import streamWidget, { selectors } from '../slice';
import { DATA_CY_DROPDOWN_STREAM_ACTIVE } from './NavigationTab/__tests__/constant';

const { Popover } = Common;

function Filter() {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState<boolean>(false);

  const {
    filterParams: { type },
  } = useSelector(selectors);
  const { label: activeFilterLabel, key: activeKey } = getActiveCategory(
    type,
    streamTypes,
  );

  const handleChangeFilter = (key: string, lsKey: string) => {
    dispatch(
      // @ts-ignore
      streamWidget.actions.setFilterParam({
        type: key,
        keyword: '',
      }),
    );
    localStorage.setItem(STREAM_STATE.TYPE, lsKey);
    setVisible(false);
  };

  const handleVisibleChange = (newOpen: boolean) => {
    setVisible(newOpen);
  };

  return (
    <Popover
      content={() => (
        <DropdownWrapper>
          {streamTypes.map(({ label, key, lsKey, dataCy }) => (
            <DropdownOption
              key={key}
              onClick={() => handleChangeFilter(key, lsKey)}
              active={key === activeKey}
              data-cy={dataCy}
            >
              {label}
            </DropdownOption>
          ))}
        </DropdownWrapper>
      )}
      trigger="click"
      placement="bottomRight"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      overlayInnerStyle={{ borderRadius: '4px' }}
    >
      <NavigationDropdown data-cy={DATA_CY_DROPDOWN_STREAM_ACTIVE}>
        {activeFilterLabel}
      </NavigationDropdown>
    </Popover>
  );
}

export default Filter;
